import eventTypeFieldService from '@/api/eventModule/eventTypeFieldServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => eventTypeFieldService
      .loadTable(pageConfig)
      .then(result => {
        commit('LOAD_LIST_EVENT_TYPE_FIELD', result.data.content)
        resolve(result)
      })
      .catch(err => reject(err)))
  },
  insertNew({ commit }, data) {
    return eventTypeFieldService
      .insertNew(data)
      .then(result => result)
      .catch(error => error)
  },
  prepareToEdit({ commit }, data) {
    commit('PREPARE_TO_EDIT_EVENT_TYPE_FIELD', data)
  },
  edit({ commit }, data) {
    return eventTypeFieldService
      .edit(data)
      .then(result => result)
      .catch(error => error)
  },
  reset({ commit }) {
    commit('RESET_EVENT_TYPE_FIELD')
  },
  delete({ commit }, id) {
    return eventTypeFieldService
      .delete(id)
      .then(result => result)
      .catch(error => error)
  },
}
